<template>
  <div>
    <h1>Create New Contest</h1>
    <div class="select-contest botm-space">
      <span class="show-contest-drop">Select Sport</span>
      <el-select class="botm-space" v-model="contest.sport" placeholder="Select">
        <el-option
          v-for="item in sports"
          :key="item.key"
          :label="item.name"
          :value="item.key">
        </el-option>
      </el-select>
    </div>
    <div class="select-contest">
      <span class="show-contest-drop">Contest Name </span>
      <el-input class="new-rule" placeholder="Ex: IPL Contest" v-model="contest.name" clearable></el-input>
    </div>
    <button class="confirm-btn" @click="enableRule(contest)">Continue
    </button>
  </div>
</template>
<script>
import { DataState } from '@/state'

export default {
  props: {
    contest: {
      type: Object,
      defult: null
    },
    contestKey: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      ruleManager: null,
      state: DataState.newNotInit(),
      moreInfo: false,
      enableChangeRule: false,
      sports: [
        {
          'key': 'cricket',
          'name': 'Cricket'
        },
        {
          'key': 'football',
          'name': 'Football'
        }
      ]
    }
  },

  mounted () {
  },

  methods: {
    enableRule (contest) {
      if (contest.sport && contest.name) {
        this.$emit('enableRule', contest)
      } else if (contest.sport == null && contest.name){
        this.$notify({
          message: 'Please select sport',
          type: 'warning'
        })
      } else if (contest.sport && (contest.name == null || contest.name == '')){
        this.$notify({
          message: 'Contest name is missing!!',
          type: 'warning'
        })
      } else {
        this.$notify({
          message: 'Please fill the fields',
          type: 'warning'
        })
      }
    }
  }
}
</script>
